import type { Bed } from './beds'

export function hasAssignedStairs(beds: Bed[], bunkId: string): boolean {
  return beds.some(b => b.kind === 'stairs' && b.servesBedIds?.includes(bunkId))
}

/** A staircase replaces ladders only on the bunks it is intended to serve. */
export function addStairToBeds(beds: Bed[], stair: Bed): Bed[] {
  return [
    ...beds.map(b => (!b.kind && stair.servesBedIds?.includes(b.id) ? { ...b, ladder: false } : b)),
    stair,
  ]
}

export function setStairBunk(beds: Bed[], stairId: string, bunkId: string, serves: boolean): Bed[] {
  const next = beds.map(b =>
    b.id === stairId && b.kind === 'stairs'
      ? {
          ...b,
          servesBedIds: serves
            ? [...new Set([...(b.servesBedIds ?? []), bunkId])]
            : (b.servesBedIds ?? []).filter(id => id !== bunkId),
        }
      : b
  )
  return next.map(b =>
    b.id === bunkId && !b.kind
      ? { ...b, ladder: serves ? false : hasAssignedStairs(next, bunkId) ? b.ladder : true }
      : b
  )
}

/** Removing the last assigned staircase restores its bunk's ladder. */
export function removeBedWithAccess(beds: Bed[], id: string): Bed[] {
  const removed = beds.find(b => b.id === id)
  const remaining = beds
    .filter(b => b.id !== id)
    .map(b =>
      b.kind === 'stairs' && b.servesBedIds?.includes(id)
        ? { ...b, servesBedIds: b.servesBedIds.filter(bunkId => bunkId !== id) }
        : b
    )
  return remaining.map(b =>
    !b.kind &&
    removed?.kind === 'stairs' &&
    removed.servesBedIds?.includes(b.id) &&
    !hasAssignedStairs(remaining, b.id)
      ? { ...b, ladder: true }
      : b
  )
}
